import { render, staticRenderFns } from "./goodsSkuImage.vue?vue&type=template&id=153a7a2c&scoped=true&"
import script from "./goodsSkuImage.vue?vue&type=script&lang=js&"
export * from "./goodsSkuImage.vue?vue&type=script&lang=js&"
import style0 from "./goodsSkuImage.vue?vue&type=style&index=0&id=153a7a2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153a7a2c",
  null
  
)

export default component.exports